import { CassetteChock } from "@/pages/catalogs/models/CassetteChock";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (c: CassetteChock) => void;
	setShowModal: (
		modal: "create" | "update" | "delete" | "deleteMultiple" | "",
	) => void;
};
export const useCassetteChockOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: CassetteChock | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Cassette Chock",
				key: "new_cassette_chock",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Cassette Chock",
					key: "edit_cassette_chock",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Cassette Chock",
					key: "delete_cassette_chock",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_cassette_chocks",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Cassette Chock",
					key: "duplicate_cassette_chock",
					onClick: () => {
						setSelectedRowData({
							...data,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
